namespace e5 {
    export class Geom {
        public static latLngToTexture(lat: number, lon: number, textureWidth: number, textureHeight: number): IPoint {
            return new Point(((lon + 180) * (textureWidth / 360)) % textureWidth,
                (((lat * -1) + 90) * (textureHeight / 180)) % textureHeight);
        }

        public static textureToLatLng(pointX: number, pointY: number, textureWidth: number, textureHeight: number): IPoint {


            var m = (pointX / textureWidth) * 180 / Math.PI;

            //            console.log(m * 1.7639164489511259);
            //            
            //            pointX /= 600;
            //            pointY /= 600;
            //            
            pointX *= 6378137;
            //            pointY *= 6378137;

            pointX = pointX / textureWidth;
            pointY = pointY / textureHeight;
            var lat = 2 * Math.atan(Math.pow(Math.E, pointY)) - .5 * Math.PI;
            var lon = pointX;
            lat = lat * 180 / Math.PI;
            lon = lon * 180 / Math.PI;
            //            console.log(lat, lon);
            return new Point(lat, lon);

            //            var lng = (pointX) / textureWidth;
            //            var latRadians = (pointY) / - textureHeight;
            //            var lat = ((2 * Math.atan(Math.exp(latRadians)) * Math.PI / 180) - Math.PI / 2);
            //            return new e5.math.Point(lat, lng);
        }

        //SOURCE (modified): http://stackoverflow.com/questions/8935117/how-can-i-convert-curveto-to-a-list-of-points
        public static interpolateQuadraticCurve(u: number, originX: number, originY: number, cpx: number, cpy: number, x: number, y: number): { x: number; y: number } {
            var B1 = (1 - u) * (1 - u);
            var B2 = 2 * u * (1 - u);
            var B3 = u * u;
            var x = originX * B1 + cpx * B2 + x * B3;
            var y = originY * B1 + cpy * B2 + y * B3;
            return { x: x, y: y };
        }

        public static sizePolygon(poly: { x: number; y: number }[]): number {
            var area = 0.0;
            var l = poly.length - 1;
            for (var k = 0; k < l; k++) {
                var xDiff = poly[k + 1].x - poly[k].x;
                var yDiff = poly[k + 1].y - poly[k].y;
                area = area + poly[k].x * yDiff - poly[k].y * xDiff;
            }
            return 0.5 * area;
        }
    }
}